// extracted by mini-css-extract-plugin
module.exports = {"headLeft":"headLeft--K9EjG","icon":"icon--1kfVo","tooltip":"tooltip--mwqC3"};